import CertificateSlider from "./CertificateSlider";

export const Certificates = () => {
    return (
        <section className="certificates" id="certificates">
            <div className="container">
                <h2 style={{ textAlign: 'center', marginBottom: '18px' }}>Certificates</h2>
                <CertificateSlider />
            </div>
        </section>
    );
};

export default Certificates;
